import {
  Box,
  Center,
  Checkbox,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from '@chakra-ui/react'
import { css } from '@emotion/react'
import { faBookOpen } from '@fortawesome/pro-regular-svg-icons'
import { faEllipsisH, faLongArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type ChangeEvent, useState } from 'react'

import TopicQ from '@/queries/TopicQ'
import type { Query } from '@/client/query'

import ShwLink from '@/components/ShwLink'

// A singular checkbox component
const TopicFilterCheckbox: React.FC<{
  topic: Query
  selectedTopics: Set<number>
  onCheck: (e: ChangeEvent<HTMLInputElement>) => void
  disabled: boolean
}> = ({ topic, selectedTopics, onCheck, disabled }) => {
  const [popoverOpen, setPopoverOpen] = useState(false)

  const topicId = topic(TopicQ.id) ?? 0
  const topicKaURL = topic(TopicQ.ka_url)

  return (
    <Checkbox
      width="100%"
      value={topicId}
      name={`${topicId}`}
      isChecked={selectedTopics.has(topicId)}
      isDisabled={disabled}
      onChange={onCheck}
      key={topicId}
      spacing="12px"
      fontSize="14px"
      borderRadius="md"
      cursor="pointer"
      _hover={{
        bg: 'bg.subtle',
      }}
      p="8px"
      color={selectedTopics.has(topicId) ? 'primary.fg' : 'fg'}
      role="group"
      css={css`
        .chakra-checkbox__label {
          width: 100%;
        }
      `}
    >
      <Flex justify="space-between" align="center">
        <Box as="span">{topic(TopicQ.name)}</Box>
        <Box width="36px" flexShrink={0}>
          <Menu isLazy onOpen={() => setPopoverOpen(true)} onClose={() => setPopoverOpen(false)}>
            <MenuButton
              as={IconButton}
              variant="icon"
              isRound
              cursor="pointer"
              display={popoverOpen ? 'flex' : 'none'}
              _groupHover={{ display: 'flex' }}
              height="24px"
              minWidth="24px"
              width="24px"
              ml="8px"
              color="gray.fg"
              _hover={{ bg: 'gray.emphasized', color: 'gray.fg' }}
              _active={{ bg: 'gray.emphasized', color: 'gray.fg' }}
              icon={<FontAwesomeIcon icon={faEllipsisH} />}
            />
            <Portal>
              <MenuList zIndex="popover">
                {topicKaURL !== null ? (
                  <ShwLink isExternal variant="unstyled" href={topicKaURL ?? ''}>
                    <MenuItem
                      value="practice"
                      fontSize="16px"
                      paddingY="8px"
                      fontWeight="100"
                      icon={
                        <Center minW="20px">
                          <FontAwesomeIcon
                            icon={faBookOpen}
                            style={{ fontSize: '16px', color: 'gray.fg' }}
                          />
                        </Center>
                      }
                    >
                      Practice on Khan Academy
                    </MenuItem>
                  </ShwLink>
                ) : null}
                <ShwLink variant="unstyled" href={`/topic/${topic(TopicQ.id)}`}>
                  <MenuItem
                    value="topic-page"
                    fontSize="16px"
                    paddingY="8px"
                    icon={
                      <Center minW="20px">
                        <FontAwesomeIcon
                          icon={faLongArrowRight}
                          style={{ fontSize: '16px', color: 'gray.fg' }}
                        />
                      </Center>
                    }
                  >
                    Visit Topic Page
                  </MenuItem>
                </ShwLink>
              </MenuList>
            </Portal>
          </Menu>
        </Box>
      </Flex>
    </Checkbox>
  )
}

export default TopicFilterCheckbox
